var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex-column" },
    [
      _c("sticky", { attrs: { className: "sub-navbar" } }, [
        _c(
          "div",
          { staticClass: "filter-container" },
          [
            _c("base-search", {
              staticStyle: { display: "inline-block" },
              attrs: {
                searchList: _vm.$processMylcSearch,
                listQuery: _vm.listQuery,
              },
              on: { search: _vm.handleFilter, "btn-event": _vm.onBtnClicked },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "app-container flex-item" },
        [
          _c(
            "el-table",
            {
              key: _vm.tableKey,
              ref: "mainTable",
              staticStyle: { width: "100%" },
              attrs: {
                height: "calc(100% - 52px)",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
              on: {
                "row-click": _vm.rowClick,
                "selection-change": _vm.handleSelectionChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { label: "实例编码", "min-width": "80px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.code))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "link-type",
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.customName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { "min-width": "80px", label: "当前活动节点" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "link-type",
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.activityName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.showDescription
                ? _c("el-table-column", {
                    attrs: { "min-width": "150px", label: "描述" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(_vm._s(scope.row.description)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3736829645
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  "class-name": "status-col",
                  label: "状态",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { class: _vm._f("statusFilter")(scope.row.isFinish) },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.statusOptions.find(
                                  (u) => u.key == scope.row.isFinish
                                ).display_name
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: {
              total: _vm.total,
              page: _vm.listQuery.page,
              limit: _vm.listQuery.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.listQuery, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.listQuery, "limit", $event)
              },
              pagination: _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }